import moment from 'moment';

// init any counters in page
const captivityCounter = document.querySelectorAll('[data-captivity-counter]');
if( captivityCounter.length > 0){

    function getTimeElapsed(date) {
        // Set the target date and time
        const targetDate = new Date(date);
        // Get the current date and time
        const currentDate = new Date();
        // Calculate the time difference in milliseconds
        const timeDifference = currentDate.getTime() - targetDate.getTime() ;
        // Calculate days, hours, minutes, and seconds
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
        // Return the result
        return {
        days,
        hours,
        minutes,
        seconds
        };
    }
    
    // Init counter
    function initCounter(counter){
        setInterval(()=>{
            const timeDifference = getTimeElapsed('2023-10-07T06:30:00+02:00');
            counter.innerHTML = `
            <div class="counter">
                <div class="counter__header">Hundreds Are Held <span>Hostage</span> By Hamas</div>
                <div class="counter__items">
                    <div class="counter__item">
                        <div class="counter__value">${timeDifference.days}</div>
                        <div class="counter__label">Days</div>
                    </div>
                    <div class="counter__div">:</div>
                    <div class="counter__item">
                        <div class="counter__value">${timeDifference.hours}</div>
                        <div class="counter__label">Hours</div>
                    </div>
                    <div class="counter__div">:</div>
                    <div class="counter__item">
                        <div class="counter__value">${timeDifference.minutes}</div>
                        <div class="counter__label">Minutes</div>
                    </div>
                    <div class="counter__div">:</div>
                    <div class="counter__item">
                        <div class="counter__value">${timeDifference.seconds}</div>
                        <div class="counter__label">Seconds</div>
                    </div>
                </div>
            </div>
            `;
        },1000);
    }

    captivityCounter.forEach(counter=>{
        initCounter(counter);
    });
}